(function () {
  'use strict';

  class SMSlideshow {
    constructor(el) {
      this.el          = el;
      this.track       = el.querySelector('.sm-track');
      this.slides      = Array.from(el.querySelectorAll('.sm-slide'));
      this.total       = this.slides.length;
      this.current     = 0;
      this.isAdapt     = el.dataset.adapt === 'true';
      this.autoplay    = el.dataset.autoplay === 'true';
      this.speed       = parseInt(el.dataset.speed, 10) * 1000;
      this.visual      = el.dataset.visual;
      this.progressBar = el.querySelector('.sm-progress');
      this.timer       = null;
      this.inTransit   = false;
      this.DURATION    = 550;

      this.init();
    }

    init() {
      this.setupLinks();
      if (this.isAdapt) { this.setAdaptHeight(); this.watchResize(); }
      if (this.total < 2) return;
      this.setupArrows();
      this.setupPagination();
      this.setupSwipe();
      this.setupKeyboard();
      if (this.autoplay) { this.startAutoplay(); this.handleVisibility(); }
    }

    /* ── Slide transition ─────────────────────────── */
    goTo(index, dir) {
      if (this.inTransit || index === this.current) return;

      const outSlide  = this.slides[this.current];
      const inSlide   = this.slides[index];
      const direction = dir !== undefined ? dir : (index > this.current ? 1 : -1);

      this.inTransit = true;

      // Place incoming slide off-screen instantly (no transition yet)
      inSlide.style.transition = 'none';
      inSlide.style.opacity    = '1';
      inSlide.style.transform  = 'translateX(' + (direction * 100) + '%)';
      inSlide.style.zIndex     = '2';

      // Force layout so browser registers starting position
      inSlide.getBoundingClientRect();

      // Enable transitions and animate
      outSlide.setAttribute('data-anim', '');
      inSlide.setAttribute('data-anim', '');
      inSlide.style.transition = '';

      requestAnimationFrame(function() {
        inSlide.style.transform  = 'translateX(0)';
        outSlide.style.transform = 'translateX(' + (-direction * 100) + '%)';
        outSlide.style.opacity   = '0';
      });

      var self = this;
      setTimeout(function() {
        outSlide.classList.remove('is-active');
        outSlide.removeAttribute('data-anim');
        outSlide.style.cssText = '';

        inSlide.classList.add('is-active');
        inSlide.removeAttribute('data-anim');
        inSlide.style.transform = '';
        inSlide.style.opacity   = '';
        inSlide.style.zIndex    = '';

        self.current   = index;
        self.inTransit = false;

        self.updatePagination();
        if (self.isAdapt) self.setAdaptHeight();
      }, this.DURATION);
    }

    next() { this.goTo((this.current + 1) % this.total, 1); }
    prev() { this.goTo((this.current - 1 + this.total) % this.total, -1); }

    /* ── Arrows ───────────────────────────────────── */
    setupArrows() {
      var self = this;
      var p = this.el.querySelector('.sm-arrow--prev');
      var n = this.el.querySelector('.sm-arrow--next');
      if (p) p.addEventListener('click', function() { self.prev(); self.resetAutoplay(); });
      if (n) n.addEventListener('click', function() { self.next(); self.resetAutoplay(); });
    }

    /* ── Dots / counter ───────────────────────────── */
    setupPagination() {
      var self = this;
      this.el.querySelectorAll('.sm-dot').forEach(function(dot) {
        dot.addEventListener('click', function() {
          self.goTo(parseInt(dot.dataset.index, 10));
          self.resetAutoplay();
        });
      });
    }

    updatePagination() {
      var self = this;
      this.el.querySelectorAll('.sm-dot').forEach(function(dot, i) {
        var active = i === self.current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', String(active));
      });
      var cur = this.el.querySelector('.sm-counter__current');
      if (cur) cur.textContent = this.current + 1;
    }

    /* ── Swipe ────────────────────────────────────── */
    setupSwipe() {
      var self = this;
      var startX = 0, startY = 0, t0 = 0;

      this.track.addEventListener('pointerdown', function(e) {
        startX = e.clientX; startY = e.clientY; t0 = Date.now();
      }, { passive: true });

      this.track.addEventListener('pointerup', function(e) {
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        if (Date.now() - t0 > 600)                    return;
        if (Math.abs(dx) < 50)                         return;
        if (Math.abs(dy) / Math.abs(dx) > 0.6)         return;
        dx > 0 ? self.prev() : self.next();
        self.resetAutoplay();
      }, { passive: true });
    }

    /* ── Keyboard ─────────────────────────────────── */
    setupKeyboard() {
      var self = this;
      this.el.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft')  { self.prev(); self.resetAutoplay(); }
        if (e.key === 'ArrowRight') { self.next(); self.resetAutoplay(); }
      });
    }

    /* ── Clickable slide links ────────────────────── */
    setupLinks() {
      var DRAG = 8;
      this.slides.forEach(function(slide) {
        if (!slide.dataset.link) return;
        var downX = 0, downY = 0;

        slide.addEventListener('pointerdown', function(e) {
          downX = e.clientX; downY = e.clientY;
        }, { capture: true, passive: true });

        slide.addEventListener('pointerup', function(e) {
          if (Math.abs(e.clientX - downX) > DRAG) return;
          if (Math.abs(e.clientY - downY) > DRAG) return;
          if (e.target.closest('button, a'))        return;
          window.location.href = slide.dataset.link;
        }, { capture: true });
      });
    }

    /* ── Adapt height ─────────────────────────────── */
    setAdaptHeight() {
      var slide  = this.slides[this.current];
      var mobile = window.innerWidth < 750;
      var ratio  = parseFloat(mobile
        ? (slide.dataset.aspectM || slide.dataset.aspectD)
        : slide.dataset.aspectD
      );
      if (ratio > 0) {
        this.track.style.height     = Math.round(this.track.offsetWidth / ratio) + 'px';
        this.track.style.paddingBottom = '0';
      }
    }

    watchResize() {
      var self = this, raf;
      window.addEventListener('resize', function() {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function() { self.setAdaptHeight(); });
      }, { passive: true });
    }

    /* ── Autoplay ─────────────────────────────────── */
    startAutoplay() {
      var self = this;
      this.pauseAutoplay();
      if (this.progressBar) {
        this.progressBar.style.transition = 'none';
        this.progressBar.style.width      = '0%';
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            self.progressBar.style.transition = 'width ' + self.speed + 'ms linear';
            self.progressBar.style.width      = '100%';
          });
        });
      }
      this.timer = setInterval(function() { self.next(); }, this.speed);
    }

    pauseAutoplay() {
      clearInterval(this.timer);
      this.timer = null;
      if (this.progressBar) {
        this.progressBar.style.transition = 'none';
        this.progressBar.style.width      = '0%';
      }
    }

    resetAutoplay() { if (this.autoplay) this.startAutoplay(); }

    handleVisibility() {
      var self = this;
      this.el.addEventListener('mouseenter', function() { self.pauseAutoplay(); });
      this.el.addEventListener('mouseleave', function() { self.startAutoplay(); });
      this.el.addEventListener('focusin',    function() { self.pauseAutoplay(); });
      this.el.addEventListener('focusout',   function() { self.startAutoplay(); });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function(entries) {
          entries[0].isIntersecting ? self.startAutoplay() : self.pauseAutoplay();
        }, { threshold: 0.3 }).observe(this.el);
      }
    }
  }

  function boot() {
    document.querySelectorAll('.sm-slideshow').forEach(function(el) {
      new SMSlideshow(el);
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();

})();
